import fetch from "node-fetch";

export default class {
  async getNavigation({ type }) {
    const res = await fetch(`${process.env.CMS_URL}/navigations/?type=${type}`);
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }
}
